import { render, staticRenderFns } from "./parmodel.vue?vue&type=template&id=3399aede&scoped=true&"
import script from "./parmodel.vue?vue&type=script&lang=js&"
export * from "./parmodel.vue?vue&type=script&lang=js&"
import style0 from "./parmodel.vue?vue&type=style&index=0&id=3399aede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3399aede",
  null
  
)

export default component.exports